import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterType", "clearCatalogFilters", "searchResultsRedirect", "onSearch"];
// @ts-ignore Could not find a declaration file for module
import { useDebouncedTextInput } from '../../../hooks/searchParamHooks';
import I18n from 'I18n';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const RouterSearchInput = _ref => {
  let {
      filterType,
      clearCatalogFilters,
      searchResultsRedirect,
      onSearch
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [inputValue, onChange] = useDebouncedTextInput(filterType, 300, clearCatalogFilters, searchResultsRedirect, onSearch);
  return /*#__PURE__*/_jsx(SearchInput, Object.assign({
    "data-test-id": `filter-type-${filterType}`,
    onChange: onChange,
    placeholder: I18n.text(`academyComponents.topFilters.${filterType}.placeholder`),
    value: inputValue
  }, rest));
};